import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLocalChargesAndDiscount, getUserData } from "../../utils/localStorage";
import StoreMenu from "../StoreMenu";
import ButtonLink from "../../ButtonLink";

const StoreCharges = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { storeData } = getUserData();

  const storeId = storeData.id;

  const [charges, setCharges] = useState([]);
  const [loading, setLoading] = useState(false);


  const fetchLocalChargesAndDiscount = async () => {
    setLoading(true);
    const { chargesAndDiscount } = getLocalChargesAndDiscount();
    if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
        const chargeArray = chargesAndDiscount.filter(
          (item) => item.chargeDiscountType === "CHARGE"
        );
        setCharges(chargeArray);
        setLoading(false);
    } else {
      setCharges([]);
      setLoading(false);
    }
  };

   useEffect(() => {
    fetchLocalChargesAndDiscount();
   }, []);

   const renderCardItem = () => {
    return charges?.map((item, index) => (
        <div>
           <div className="flex-1">
            <div
              className="flex-1  surface-0"
              style={{ "--surface-0": "#EAEFF5" }}
            >
              <div className="flex justify-content-between mx-4">
                <div className="py-1">
                  <p className=" text-xl  font-bold ">
                    {item.name}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Charges Type :
                  </p>
                  <p className="text-lg font-medium capitalize">{item.chargeDiscountType}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Charges In :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.chargeDiscountTypeIn}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Charges Description :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.description}
                  </p>
                </div>
               
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Charges :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.chargeDiscount}
                  </p>
                </div>

                  
                
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Store Charges
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      {renderCardItem()}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default StoreCharges;
